<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="用户姓名">
          <el-input size="mini" v-model="params.Name" placeholder="请输入用户姓名" clearable />
        </el-form-item>
        <el-form-item label="用户账号">
          <el-input size="mini" v-model="params.LoginId" placeholder="请输入用户账号" />
        </el-form-item>
        <el-form-item label="所属角色">
          <role-select ref="roleSelect" v-model="params.RoleId" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select size="mini" v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="TeacherName" label="用户姓名" min-width="120px" />
        <el-table-column prop="LoginId" label="用户账号" min-width="120px" />
        <el-table-column prop="RoleName" label="角色名称" min-width="120px" />
        <el-table-column prop="Status" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag size="mini" type="success" v-if="row.Status == 1">启用</el-tag>
            <el-tag size="mini" type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

import roleSelect from "@/components/sys/role/select";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list, roleSelect, exportDialog },
  data() {
    return {
      api: require("@/api/sy/user").default,
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
    };
  },
  methods: {
    onExport() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
    logout(data) {
      console.log("logout", data);
      this.api.forceLogout({ UserId: data.UserId }).then((res) => {
        this.reload();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>